import React from "react";
import {
  GraduationCap,
  Signal,
  Video,
  Code,
  ArrowRight,
  Calendar,
  Briefcase,
  ShieldCheck,
  Wrench,
  Users,
} from "lucide-react";

const expertiseItems = [
  {
    icon: <Signal />,
    title: "Trading Signals",
    desc: "Monetize your trading strategies by providing transparent, performance-tracked market signals to a global audience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Ftradingsignals.jpg?alt=media&token=9ad8bc01-4d15-469a-830e-366ca690332d",
  },
  {
    icon: <GraduationCap />,
    title: "Mentorship & Coaching",
    desc: "Earn by sharing your experience through one-to-one or group mentorship programs tailored for traders and investors.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Fmentorship.jpg?alt=media&token=3236f1a5-be73-4d3c-a749-94be270d0acb",
  },
  {
    icon: <Video />,
    title: "Courses & Webinars",
    desc: "Create and sell recorded courses or host live webinars to educate and guide the market community at scale.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Flive-webinar.jpg?alt=media&token=851e2d9c-dcce-4b18-abd1-b172a1986f2e",
  },
  {
    icon: <Calendar />,
    title: "Bookings & Appointments",
    desc: "Offer paid personal sessions such as coaching calls, advisory meetings, and portfolio review appointments.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Fbookings.jpg?alt=media&token=73a0936c-0bd8-496a-ab9f-33ccb15e97e6",
  },
  {
    icon: <Briefcase />,
    title: "Portfolio & Account Management",
    desc: "Provide professional portfolio handling, fund oversight, and structured account management services for clients.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Fportfolio-management.jpg?alt=media&token=929acb63-4241-4fc6-a1a1-0e06bae8d468",
  },
  {
    icon: <ShieldCheck />,
    title: "Risk Management & Legal Advisory ",
    desc: "Deliver compliance guidance, regulatory support, and risk-assessment services for traders, firms, and funds.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Flegal-risk.jpg?alt=media&token=b9e74a1a-ebd7-4821-b9b6-ae709c2b70c1",
  },
  {
    icon: <Wrench />,
    title: "Freelance & Skill Services",
    desc: "Sell your skills in trading, analysis, research, development, automation, or financial operations as a service.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Ffreelancers.jpg?alt=media&token=764ac6bd-15d3-4fc1-b8da-bc2c54d4875e",
  },
  {
    icon: <Users />,
    title: "Jobs & Hiring Board",
    desc: "Post opportunities or discover roles across trading, finance, analytics, technology, and fund management.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/expertise%2Fjobboard.jpg?alt=media&token=ccebe92d-c6e6-4e0a-998f-2d55068e34ce",
  },
];

export default function SellYourExpertise() {
  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-12 text-left">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Sell Your <span className="text-blue-600">Expertise</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Turn your knowledge, skills, products, and services into real income
            — whether you are an individual professional, a business, or an
            institution.
          </p>
        </div>

        {/* Dark Container */}
        <div className="rounded-3xl border border-white/5 bg-[#0B0F19] px-6 py-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {expertiseItems.map((item, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40"
              >
                {/* IMAGE BOX */}
                <div className="w-full overflow-hidden border border-white/10 bg-white/5">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-auto w-full object-cover"
                  />
                </div>

                {/* CONTENT */}
                <div className="p-8">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white">
                    {item.icon}
                  </div>

                  <h3 className="mt-5 text-lg font-semibold text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-400">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <button className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-3 font-medium text-white hover:bg-blue-700">
              Start Selling
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
